export var SortingConfiguration;
(function (SortingConfiguration) {
    SortingConfiguration[SortingConfiguration["Alphabetically"] = 0] = "Alphabetically";
    SortingConfiguration[SortingConfiguration["ByOrderId"] = 1] = "ByOrderId";
})(SortingConfiguration || (SortingConfiguration = {}));
//# sourceMappingURL=SortingConfiguration.js.map